import { Configuration } from '@reliance/types/models/Configuration';
import { IApiService } from '../services/api_service';

export const configuration = (siteApi: IApiService) => ({
  get: (key?): Promise<Configuration> => {
    return siteApi.get('/configuration', { params: { key } });
  }
});
